"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultCommonConfig = exports.DefaultConsentPolicy = exports.BrandToHostMap = exports.DefaultBrand = exports.EventContextMap = exports.BackofficeDomains = exports.LoggerVersion = void 0;
exports.LoggerVersion = '2.0.1000';
exports.BackofficeDomains = ['.wix.com', '.editorx.com'];
var EventContextMap;
(function (EventContextMap) {
    EventContextMap["msid"] = "_msid";
    EventContextMap["clientId"] = "_client_id";
    EventContextMap["uuid"] = "_uuid";
    EventContextMap["visitorId"] = "_visitorId";
    EventContextMap["siteMemberId"] = "_siteMemberId";
    EventContextMap["brandId"] = "_brandId";
    EventContextMap["siteBranchId"] = "_siteBranchId";
    EventContextMap["ms"] = "_ms";
    EventContextMap["lv"] = "_lv";
})(EventContextMap = exports.EventContextMap || (exports.EventContextMap = {}));
exports.DefaultBrand = 'wix';
exports.BrandToHostMap = {
    wix: 'wix',
    editorx: 'editorx',
};
exports.DefaultConsentPolicy = {
    functional: true,
    analytics: true,
};
exports.DefaultCommonConfig = {
    brand: exports.DefaultBrand,
};
//# sourceMappingURL=constants.js.map